// 直播间页
const room = () =>
  import(/* webpackChunkName: "Index" */ "@/views/roomModule/room");
// 直播间列表
const roomList = () =>
  import(
    /* webpackChunkName: "Index" */ "@/views/roomModule/roomModuleList/roomList"
  );
// 直播间列表详情
const roomDetail = () =>
  import(
    /* webpackChunkName: "Index" */ "@/views/roomModule/roomModuleList/roomListDetail"
  );
  // 京东列表详情
const JDRoomDetail = () =>
  import(
    /* webpackChunkName: "Index" */ "@/views/roomModule/roomModuleList/JDRoomDetail"
  );
// 企业号
const qyRoomDetail = () =>
  import(
    /* webpackChunkName: "Index" */ "@/views/roomModule/roomModuleList/qyRoomListDetail"
  );
// 快手号大屏
const ksRoomDetail = () =>
  import(
    /* webpackChunkName: "Index" */ "@/views/roomModule/roomModuleList/ksRoomListDetail"
  );
// 腾讯视频号
const videoRoomListDetail = () =>
  import(
    /* webpackChunkName: "Index" */ "@/views/roomModule/roomModuleList/videoRoomListDetail"
  );
// 直播间管理
const roomManage = () =>
  import(/* webpackChunkName: "Index" */ "@/views/roomModule/index");
// 场次列表
const liveBroadcastRoom = () =>
  import(
    /* webpackChunkName: "Index" */ "@/views/roomModule/liveBroadcastRoom"
  );
// 添加场次
const addSession = () =>
  import(/* webpackChunkName: "Index" */ "@/views/roomModule/addSession");
const livestatement = () => import(/* webpackChunkName: "Index" */ '@/views/statementModule/livestatement')

// 排班日历
const schedule= () =>
import(
  /* webpackChunkName: "Index" */ "@/views/roomModule/scheduleCalendar/index.vue"
);
// 排班日历
const scheduleComplex= () =>
import(
  /* webpackChunkName: "Index" */ "@/views/roomModule/scheduleCalendar/indexTwo.vue"
);
// 添加主播
const submitAnchor = () =>
import(
  /* webpackChunkName: "Index" */ "@/views/roomModule/scheduleCalendar/submitAnchor.vue"
);
// 添加主播
const submitAnchorTwo = () =>
import(
  /* webpackChunkName: "Index" */ "@/views/roomModule/scheduleCalendar/submitAnchorTwo.vue"
);
// 添加副播
const addSecondaryBroadcast = () => import("@/views/matchAreaController/assistantAnchor/submitAnchorTwo");
//日历详情
const crewScheduling = () => import("@/views/roomModule/scheduleCalendar/crewScheduling");

const roomRouter = [
  {
    path: "/index",
    redirect: "/admin/home",
    component: () => import("@/views/loginModule/index"),
    children: [
      {
        path: "/admin/room",
        name: "room",
        redirect: "/admin/room/roomList",
        component: room,
        meta: {
          title: "直播间",
        },
        children: [
          {
            path: '/admin/statement/livestatement',
            name: 'livestatement',
            component: livestatement,
            meta: {
              title: '报表'
            },
          },
          {
            path: "/admin/room/roomMage",
            name: "roomMage",
            component: roomManage,
            meta: {
              title: "直播间管理",
            },
          },
          {
            path: "/admin/room/roomList",
            name: "room",
            component: roomList,
            meta: {
              title: "直播间数据",
            },
          },
          // 抖音大屏
          {
            path: "/admin/room/roomDetail",
            name: "roomDetail",
            component: roomDetail,
            meta: {
              title: "直播间管理",
            },
          },
          // 企业号抖音大屏
          {
            path: "/admin/room/qyRoomDetail",
            name: "qyRoomDetail",
            component: qyRoomDetail,
            meta: {
              title: "直播间管理",
            },
          },
          // 快手号抖音大屏
          {
            path: "/admin/room/ksRoomDetail",
            name: "ksRoomDetail",
            component: ksRoomDetail,
            meta: {
              title: "直播间管理",
            },
          },
          // 京东大屏
          {
            path: "/admin/room/JDRoomDetail",
            name: "JDRoomDetail",
            component: JDRoomDetail,
            meta: {
              title: "直播间管理",
            },
          },
          // 腾讯视频号抖音大屏
          {
            path: "/admin/room/videoRoomListDetail",
            name: "videoRoomListDetail",
            component: videoRoomListDetail,
            meta: {
              title: "直播间管理",
            },
          },
          {
            path: "/admin/room/liveBroadcastRoom",
            name: "liveBroadcastRoom",
            component: liveBroadcastRoom,
            meta: {
              title: "直播间管理",
            },
          },
          {
            path: "/admin/room/addSession",
            name: "addSession",
            component: addSession,
            meta: {
              title: "直播间管理",
            },
          },
          {
            path: "/admin/room/scheduleCalendar",
            name: "scheduleCalendar",
            component: schedule,
            meta: {
              title: "直播间日历",
            },
          },
          {
            path: "/admin/room/crewScheduling",
            name: "crewScheduling",
            component: crewScheduling,
            meta: {
              title: "排班日历",
            },
          },
          {
            path: "/admin/room/scheduleCalendarComplex",
            name: "scheduleCalendarComplex",
            component: scheduleComplex,
            meta: {
              title: "直播日程",
            },
          },
          {
            path: "/admin/room/submitAnchor",
            name: "submitAnchor",
            component: submitAnchor,
            meta: {
              title: "直播间",
            },
          },
          {
            path: "/admin/room/submitAnchorTwo",
            name: "submitAnchorTwo",
            component: submitAnchorTwo,
            meta: {
              title: "主播管理",
            },
          },
          {
            path: "/admin/room/addSecondaryBroadcast",
            name: "addSecondaryBroadcast",
            component: addSecondaryBroadcast,
            meta: {
              title: "副播管理",
            },
          },

        ],
      },
    ],
  },
];
export default roomRouter;
